module.exports = __webpack_public_path__ + "static/media/axegprokeyboard-2.30e38fa0.jpg";